module.exports = "/assets/data/2b33101b09c1fa79c6f4d8520917788f-NE16.data.json";